import { Box as MantineBox } from "@mantine/core";

export const Box = MantineBox;
